import { Dialog, Sheet } from "@gravity-ui/uikit";
import { useGravityDevice } from "src/hooks/useGravityDevice";
import { DontHaveSubscribeBlock } from "src/widgets";

import { CertInfo } from "../../components/CertInfo/CertInfo";
import { useCertInfo } from "./hooks/useCertInfo.ts";

interface CertInfoModalProps {
  open: boolean;
  onClose: () => void;
  certNo: string;
}

export const CertInfoModal = ({
  open,
  onClose,
  certNo,
}: CertInfoModalProps) => {
  const { isMobile } = useGravityDevice();

  const { certInfo, isLoading, hasMoney } = useCertInfo(certNo);
  const ContentContainer = isMobile ? Sheet : Dialog;
  return (
    <ContentContainer open={open} visible={open} onClose={onClose} size="l">
      {!isMobile && <Dialog.Header caption={"\u200C"} />}
      <Dialog.Body>
        {hasMoney ? (
          <CertInfo certInfo={certInfo} isLoading={isLoading} />
        ) : (
          <DontHaveSubscribeBlock />
        )}
      </Dialog.Body>
    </ContentContainer>
  );
};
